import { apiCustomer } from "../../../api/api-customer";
import { CUSTOMER_CODE } from "../../../common/utils/static-data";
import { alert } from "../../../common/utils/alert";
import { emitter } from "../../../common/utils/emitter";

export const submit = (
  context,
  isModal,
  visiableOkButtonOnModal,
  setCustomerOnModal
) => {
  context.form
    .validateFields()
    .then(async (values) => {
      if (!isModal) {
        emitter.emit("FETCH_LOADING", true);
      } else {
        visiableOkButtonOnModal(true);
      }

      const newCustomerState = context.newCustomer.state;
      const newAdminUserState = context.adminUser.state;
      const { customer } = newCustomerState;

      if (values.customer_type === CUSTOMER_CODE.enterprise) {
        const addNewUserState = isModal
          ? { phoneUsers: [] }
          : context.addNewUser.state;

        const { phoneUsers } = addNewUserState;
        let dto = {};

        try {
          dto = {
            admin: {
              password:
                context.state.typeOption === "edit" &&
                context.state.checkEditPass
                  ? values.password
                  : null,
              active: values.accountStatus === 0 ? true : false,
              code: values.signinName.trim(),
              name: values.admin_name.trim(),
              department: values.department.trim(),
              email: values.email.trim(),
              is_new: newAdminUserState.id ? false : true,
              ...newAdminUserState, // lấy country_code, iso2, mobile trong state
            },
            customer: {
              ...customer, // lấy customer để edit trong state khi được select dropdown
              name: values.name.trim().replace(/(\r\n|\n|\r)/gm, " "),
              address: values.address.trim(),
              tax_code: values.tax_code.trim(),
              bank_account_holder:
                values.bank_account_holder && values.bank_account_holder.trim(),
              bank_name: values.bank_name && values.bank_name.trim(),
              bank_account_number:
                values.bank_account_number && values.bank_account_number.trim(),
              is_new: customer.customer_id ? false : true,
              id: customer.customer_id,
            },
            users: values.users
              ? values.users.map((item, index) => {
                  return {
                    is_new: phoneUsers[index].id ? false : true,
                    ...item,
                    name: item.name.trim(),
                    email: item.email.trim(),
                    department: item.department.trim(),
                    ...phoneUsers[index], // lấy từng phone đã lưu trong state đẩy vào user
                    active: true,
                    password:
                      item.password !== "Avis@qwer2020" ? item.password : "",
                  };
                })
              : [],
          };
        } catch (error) {}

        try {
          const result = await apiCustomer.createOrEditEnterpriseCustomer(dto);
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
          if (result.status === "success") {
            if (isModal) {
              setCustomerOnModal(result.data);
            }
            alert("success", "Cập nhật khách hàng thành công!");
            context.props.close && context.props.close();
          } else {
            alert("error", result.data.message);
          }
        } catch (error) {
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
        }
      } else {
        let dto = {
          ...customer,
          name: values.name
            ? values.name.trim().replace(/(\r\n|\n|\r)/gm, " ")
            : null,
          address: values.address ? values.address.trim() : null,
          tax_code: values.tax_code ? values.tax_code.trim() : null,
          bank_account_holder: values.bank_account_holder
            ? values.bank_account_holder.trim()
            : null,
          bank_name: values.bank_name ? values.bank_name.trim() : null,
          bank_account_number: values.bank_account_number
            ? values.bank_account_number.trim()
            : null,
          position: values.department ? values.department.trim() : null,
          email: values.email,
          is_new: customer.customer_id ? false : true,
          id: customer.customer_id,
          ...newAdminUserState,
          phone_number: newAdminUserState.mobile,
          id_card: values.id_card,
          card_type: values.card_type,
          code: values.signinName,
          active: values.accountStatus === 0 ? true : false,
          password:
            context.state.typeOption === "edit" && context.state.checkEditPass
              ? values.password
              : null,
        };
        try {
          let func = apiCustomer.createPersonalCustomer;
          if (dto.id) {
            func = apiCustomer.editPersonalCustomer;
          }
          const result = await func(dto);
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
          if (result.status === "success") {
            if (isModal) {
              setCustomerOnModal(result.data);
            }
            alert("success", "Cập nhật khách hàng thành công!");
            context.props.close && context.props.close();
          } else {
            alert("error", result.data.message);
          }
        } catch (error) {
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
        }
      }
    })
    .catch((err) => {});
};

export const userConvert = async (customer, context) => {
  const newCustomer = context.newCustomer;
  const newAdminUser = context.adminUser;
  context.setState({
    enterprise: customer.customer_type === CUSTOMER_CODE.enterprise,
  });
  if (customer.customer_type === CUSTOMER_CODE.enterprise) {
    emitter.emit("FETCH_LOADING", true);
    try {
      const result = await apiCustomer.getCustomerEnterpriseDetail(
        customer.member_customer_id
      );
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        context.setState({
          isInContract: result.data.in_contract,
        });

        // set state cho customer component
        newCustomer.setState({
          customer: result.data.customer,
        });

        // set state for admin user component
        newAdminUser.setState({
          country_code: result.data.country_code,
          iso2: result.data.iso2 ? result.data.iso2 : "vn",
          mobile: result.data.mobile,
          id: result.data.id,
        });

        //set phones state for addNew User component
        const addNewUser = context.addNewUser;
        addNewUser.setState({
          phoneUsers: result.data.children.map((value) => {
            return {
              country_code: value.country_code,
              iso2: value.iso2 ? value.iso2 : "vn",
              mobile: value.mobile,
              id: value.id,
              isInContract: value.in_contract,
            };
          }),
        });

        context.form.setFieldsValue({
          customer_type: "CT002",
          mobile: `+${result.data.country_code}` + result.data.mobile,
          admin_name: result.data.name,
          department: result.data.department,
          email: result.data.email,
          name: result.data.customer.name,
          address: result.data.customer.address,
          tax_code: result.data.customer.tax_code,
          bank_account_holder: result.data.customer.bank_account_holder,
          bank_name: result.data.customer.bank_name,
          bank_account_number: result.data.customer.bank_account_number,
          signinName: result.data.code,
          accountStatus: result.data.active === true ? 0 : 1,
          users: result.data.children.map((user) => {
            return {
              ...user,
              mobile: `+${user.country_code}` + user.mobile,
              username: user.code,
              password: "Avis@qwer2020",
              edit: true,
            };
          }),
        });
      } else {
        // alert('error', result.data.message)
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  } else {
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiCustomer.getCustomerPersonalDetail(
        customer.customer_id
      );
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        newCustomer.setState({
          customer: result.data,
        });
        context.setState({
          isInContract: result.data.in_contract,
        });
        // set state for admin user component
        newAdminUser.setState({
          country_code: result.data.country_code,
          iso2: result.data.iso2 ? result.data.iso2 : "vn",
          mobile: result.data.phone_number,
        });
        context.form.setFieldsValue({
          ...result.data,
          customer_type: "CT001",
          mobile: `+${result.data.country_code}` + result.data.phone_number,
          department: result.data.position,
          signinName: result.data.code,
          accountStatus: result.data.active === true ? 0 : 1,
        });
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  }
};

export const checkUserType = (title) => {
  return ({ getFieldValue }) => ({
    validator(rule, v) {
      const customer_type = getFieldValue("customer_type");
      if (customer_type === CUSTOMER_CODE.personal) {
        if (v && v.length > 100) {
          return Promise.reject(`${title} vượt quá 100 ký tự!`);
        }
        return Promise.resolve();
      } else {
        if (!v) {
          return Promise.reject(`Vui lòng nhập ${title}!`);
        }
        if (v.length > 100) {
          return Promise.reject(`${title} vượt quá 100 ký tự!`);
        }
        return Promise.resolve();
      }
    },
  });
};
